import {
  FaFacebook,
  FaGoogle,
  FaInstagram,
  FaLinkedin,
  FaPinterest,
  FaTumblr,
  FaYoutube,
} from "react-icons/fa";
import { SiThreads, SiX } from "react-icons/si";

/**
 * Footer social icons — official Panthi Events profiles (opens in new tab).
 */
export const FOOTER_SOCIAL_LINKS = [
  {
    id: "google-business",
    label: "Google Business Profile",
    href: "https://share.google/jOegrw0JbmUuS8DS3",
    Icon: FaGoogle,
  },
  {
    id: "youtube",
    label: "YouTube",
    href: "https://www.youtube.com/@PanthiEvents",
    Icon: FaYoutube,
  },
  {
    id: "instagram",
    label: "Instagram",
    href: "https://www.instagram.com/panthievent",
    Icon: FaInstagram,
  },
  {
    id: "facebook",
    label: "Facebook",
    href: "https://www.facebook.com/PanthiEvent",
    Icon: FaFacebook,
  },
  {
    id: "pinterest",
    label: "Pinterest",
    href: "https://in.pinterest.com/PanthiEvent/",
    Icon: FaPinterest,
  },
  {
    id: "threads",
    label: "Threads",
    href: "https://www.threads.com/@panthievent",
    Icon: SiThreads,
  },
  {
    id: "linkedin",
    label: "LinkedIn",
    href: "https://www.linkedin.com/company/panthievent",
    Icon: FaLinkedin,
  },
  {
    id: "x",
    label: "X",
    href: "https://x.com/panthievent",
    Icon: SiX,
  },
  {
    id: "tumblr",
    label: "Tumblr",
    href: "https://www.tumblr.com/panthievent",
    Icon: FaTumblr,
  },
];
